import { registerBasicWidgets } from "./basic";
import { registerCompositeWidgets } from "./composite";
import { registerDocumentWidgets } from "./documents";
import { listWidgets } from "./registry";

let done = false;

/** Registers the built-in widget set once. Hosts may register more widgets before or after. */
export function ensureBuiltInWidgets(): void {
  if (done) return;
  done = true;
  registerBasicWidgets();
  registerCompositeWidgets();
  registerDocumentWidgets();
}

/** Built-in widgets grouped by category for palettes. */
export function widgetPalette() {
  ensureBuiltInWidgets();
  const order = ["basic", "number", "date", "choice", "composite", "documents", "layout"] as const;
  return order.map((category) => ({ category, widgets: listWidgets().filter((w) => w.category === category) })).filter((g) => g.widgets.length > 0);
}

export * from "./registry";
export { partySchema, turnoverTableSchema, marketTableSchema, type TableColumn } from "./composite";
export { documentChecklistSchema, type DocumentSpec, type DocumentEntry } from "./documents";
